import { createApiAction } from '@app/packages/api/utils'
import type { ApiPerk } from '@app/packages/api/v2/types/entities'

export const getPerks = () => createApiAction('getPerks', dispatch => dispatch<{ data: ApiPerk[] }>({ method: 'GET', endpoint: '/api/v2/perks' }))
